import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { Row, Col } from 'react-bootstrap';
import { Text, Button, ButtonModal } from 'react-orange-ui';
import { isMobile } from "react-device-detect";

import Title from '../../Title/Title';

import WordingService from '../../../services/WordingService';
import TagService from '../../../services/TagService';
import ConfidentialMessage from './ConfidentialMessage';

/**
 * Check if current date is between feedback projected dates
 */
function feedBackIsActive(today = new Date()) {
  const startDate = Date.parse(window.reactAppEnv.features.feedbackStartDate);
  const endDate = Date.parse(window.reactAppEnv.features.feedbackEndDate);
  const date = Date.parse(today);
  return ((startDate <= date) && (date <= endDate));
}

class ConfirmView extends Component {
  constructor(props) {
    super(props);
    this.state = {
      dialogIsOpen: window.reactAppEnv.features.feedback && feedBackIsActive(),
    }
  }

  /**
   * Reload contacts with non obfuscated data on mount
   */
  componentDidMount() {
    const { dialogIsOpen } = this.state;

    if (dialogIsOpen) {
      TagService.sendScreen('openDialog');
    }
  }

  handleSubmit = (e) => {
    e.preventDefault();
    const { serviceConf, quitApp } = this.props;

    switch (serviceConf.dictionary) {
      case 'multibal':
        TagService.sendAction('backToManageBal');
        this.handleRedirectManageBal();
        break;
      default:
        TagService.sendAction('auth');
        quitApp();
        break;
    }
  }

  /**
   * Close dialog
   */
  closeDialog = () => {
    this.setState({ dialogIsOpen: false }, () => {
      TagService.sendAction('closeDialog');
    });
  }

  /**
   * Redirect to Harris form url
   */
  goToHarrisFeedbackForm = () => {
    TagService.sendAction('openFeedback');
    window.open(window.reactAppEnv.href.harrisFeedbackForm, '_blank');
  }

  /**
   * Redirect user to the secondary list accounts
   */
  handleRedirectManageBal = () => {
    window.location.href = window.reactAppEnv.href.manageBal;
  }

  render() {
    const { serviceConf, webViewFlag } = this.props;
    const { dialogIsOpen } = this.state;

    return (
      <form id="confirm-form" onSubmit={this.handleSubmit}>
        <Row>
          <Col sm={12}>
            <Title id="confirmation" label={WordingService.getWording('title', 'passwordIsSaved')} icon="tick" size={32} color="green" />
            <br />
            <Text id="confirmation-service-help">{WordingService.getWording('caption', 'serviceHelp')}</Text>
            <br />
            <Button htmlType="submit" id="auth-button" type="fill">
              {WordingService.getWording('button', 'login')}
            </Button>
            {(serviceConf.dictionary !== 'multibal') && <ConfidentialMessage webViewFlag={webViewFlag} />}
            {dialogIsOpen && (
              <ButtonModal
                title="Votre avis nous intéresse"
                button={{ ok: isMobile ? 'Répondre' : 'Répondre au questionnaire', close: 'Fermer' }}
                width={isMobile ? '90%' : '50%'}
                onClickOnCloseButton={this.closeDialog}
                onClickOnCloseIcon={this.closeDialog}
                onClickOnSubmitButton={this.goToHarrisFeedbackForm}>
                Comment s&apos;est passée la modification ou la création de votre mot de passe ?<br /><br />Donnez votre avis et tentez de gagner un iPhone XR.
              </ButtonModal>
            )}
          </Col>
        </Row>
      </form>
    );
  }
}

ConfirmView.defaultProps = {
  webViewFlag: false,
};

ConfirmView.propTypes = {
  /** Action to quit the app */
  quitApp: PropTypes.func.isRequired,
  /** Flag to know if the app is in webView Mode */
  webViewFlag: PropTypes.bool,
  /** Object service configuration */
  serviceConf: PropTypes.shape(),
};


export default ConfirmView;
